import { Injectable, Injector } from '@angular/core';
import { AbstractControlOptions, UntypedFormArray } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { UserDao } from '@app/dao/user/user.dao';
import { AvDistribution } from '@app/forms/subscription/definition/interface/subscription';
import { FormConfig } from '@app/forms/subscription/definition/types/subscription';
import { take } from 'rxjs';
import { PledgeProductRead } from '../../definition/interface/Pledge';
import FormGroupArray from '../../services/FormGroupArray';
@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  userId;
  constructor(
    protected formConstructor: PrFormConstructor,

    protected injector: Injector,
  ) {
    super(formConstructor);
    injector
      .get(UserDao)
      .getAuthentified()
      .pipe(take(1))
      .subscribe(user => {
        this.userId = user.id;
      });
  }

  generateForm(entity: PledgeProductRead & { parameters: any }) {
    let options: AbstractControlOptions = {};
    const formConfig: FormConfig<PledgeProductRead & { parameters: any }> = {
      id: [entity.id],
      type: [entity.type],
      productId: [entity.productId],
      productName: [entity.productName],
      status: [entity.status],
      parameters: this.formBuilder.group({
        avDistribution: [
          entity?.parameters?.avDistribution
            ? entity.parameters.avDistribution
            : 'FREE',
        ],
      }),
    };

    return this.formBuilder.group(formConfig, options);
  }

  generate(entity: AvDistribution[], option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
      propertyName: 'products',
    });
  }
  get products() {
    return this.form.get('products') as UntypedFormArray;
  }
  extract() {
    return this.form.value.products.map((product, index) => {
      const originalAvDistribution =
        this.entity?.products?.[index]?.parameters?.avDistribution;
      const currentAvDistribution = product.parameters?.avDistribution;

      if (
        originalAvDistribution &&
        currentAvDistribution !== originalAvDistribution
      ) {
        return {
          ...product,
          parameters: {
            ...product.parameters,
            supportRepartition: [],
          },
        };
      }

      return product;
    });
  }
}
